module.exports = __webpack_public_path__ + "04fe776a70ab9093b49c749fcea846e6.svg";